<template>
  <div class="skeleton-overview">
    <div class="skeleton-overview__grid">
      <div class="skeleton-overview__grid__header">
        <div
          class="skeleton-overview__grid__header__icon skeleton__animate--white"
        ></div>
        <div class="skeleton-overview__grid__header__desc">
          <p class="skeleton__content skeleton__animate--white"></p>
        </div>
      </div>
      <h2 class="skeleton-overview__grid__title skeleton__animate--white"></h2>
      <div class="skeleton-overview__grid__description">
        <p
          class="skeleton__content skeleton__animate skeleton__animate--white"
        ></p>
        <p
          class="skeleton__content skeleton__animate skeleton__animate--white"
        ></p>
        <p
          class="skeleton__content skeleton__animate skeleton__animate--white"
        ></p>
        <p
          class="skeleton__content skeleton__animate skeleton__animate--white"
        ></p>
        <p
          class="skeleton__content skeleton__animate skeleton__animate--white"
        ></p>
        <p
          class="skeleton__content skeleton__animate skeleton__animate--white"
        ></p>
      </div>
      <div class="skeleton-overview__grid__instructor-wrapper">
        <div
          class="skeleton-overview__grid__instructor-wrapper__avatar skeleton__animate--white"
        ></div>
        <div
          class="skeleton-overview__grid__instructor-wrapper__name skeleton__animate--white"
        ></div>
        <div class="skeleton-overview__grid__instructor-wrapper__summary">
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
        </div>
        <div
          class="skeleton-overview__grid__instructor-wrapper__pill skeleton__animate--white"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PathOverviewSkel',
}
</script>

<style lang="scss" scoped>
.skeleton-overview {
  display: flex;
  justify-content: center;
  padding: 100px 20px 60px;
  @include mobile {
    padding: 120px 20px;
  }
  @include desktop {
    padding: 170px 100px 120px;
  }
  &__grid {
    display: flex;
    flex-flow: column;
    max-width: 1400px;
    width: 100%;

    @include mobile {
      display: grid;
      grid-auto-rows: auto;
      grid-template-columns: auto 350px;
      grid-gap: 0 10px;
    }
    @include desktop {
      grid-template-columns: auto 400px;
      grid-gap: 0;
      grid-gap: 0 50px;
    }

    &__header {
      display: flex;
      align-items: center;
      gap: 10px;
      &__icon {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
      &__desc {
        flex: 1;
        p {
          margin: 0;
          height: 28px;
        }
      }
    }
    &__title {
      height: 38px;
      margin: 10px 0 0 0;
      width: 100%;
      grid-row: 2;
      grid-column: 1 / 3;

      @include mobile {
        height: 52px;
        width: 50%;
      }
      @include desktop {
        grid-column: 1;
      }
    }
    &__description {
      margin: 30px 0 0 0;

      @include mobile {
        grid-row: 4;
        grid-column: 1;
      }
      @include desktop {
        grid-row: auto;
      }
    }
    &__instructor-wrapper {
      display: flex;
      flex-flow: column;
      align-items: center;
      margin-top: 30px;
      padding: 20px;
      width: 100%;

      @include mobile {
        grid-column: 2;
        grid-row: 4;
      }

      @include desktop {
        grid-row: 1 / 6;
        margin: 0;
      }

      &__avatar {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
      &__name {
        margin-top: 10px;
        width: 50%;
        height: 26px;
      }
      &__summary {
        display: flex;
        margin-top: 20px;
        width: 100%;
        flex-flow: column;
      }
      &__pill {
        margin-top: 20px;
        width: 70%;
        height: 32px;
        border-radius: 100px;
      }
    }
  }
}
</style>
